export var NETWORK_ONLY = 'network-only';
export var STORE_THEN_NETWORK = 'store-and-network';
export var STORE_OR_NETWORK = 'store-or-network';
export var STORE_ONLY = 'store-only';
export var PAGINATION_NAME = 'usePagination';
export var REFETCHABLE_NAME = 'useRefetchable';
export var FRAGMENT_NAME = 'useFragment'; // pagination

export var FORWARD = 'forward';